/**
 * `a-session` (process/09-SCREEN-SPECS/a-session.md) is "the refresh-failure state" — entered
 * when an authenticated call fails mid-session, not from any action `AuthLayer`'s own reducer
 * dispatches. There is no context provider threading `AppRoot`'s phase down to
 * `data/apiClient.ts` (and there should not be one just for this), so this is the one place that
 * edge is crossed: `apiClient.ts` calls `notifySessionEnded()` when it sees the shape; `AppRoot`
 * is the only subscriber, and only while it is past the auth phase (subscribing during `auth`
 * itself would be reacting to sign-in's OWN failures, which already have their own handling).
 */
let handler: (() => void) | undefined

export function registerSessionEndedHandler(fn: (() => void) | undefined): void {
  handler = fn
}

export function notifySessionEnded(): void {
  handler?.()
}
